<script setup>
    // Component
    import MainHeader from '@/components/HeaderComponent.vue';

    // Store
    import { useTouStore } from '@/stores/common/touStore';

    // Utis
    import utils from '@/commonProject/helpers/utils';

    const touStore = useTouStore();
</script>

<style></style>

<template>
    <section id="main">
        <MainHeader />
        <div id="contents">
            <div class="whiteBox">
                <section class="whiteBoxContents heightFullSize">
                    <p class="pageInfo"><img src="/img/icon_caution.svg" width="30" height="30" /></p>
                    <p class="pageInfo">{{ $t('error.parts.pageTitle2') }}<br />{{ $t('error.parts.pageInformation1') }}</p>
                    <p class="pageInfo">{{ $t('error.parts.pageInformation2') }}</p>
                    <p class="pageInfo">
                        <span style="text-align: left; width: 100%; position: relative; display: block; padding-left: 30px; box-sizing: border-box">{{ $t('error.parts.pageInformation3') }}</span>
                        <span style="text-align: left; width: 100%; position: relative; display: block; padding-left: 30px; box-sizing: border-box">{{ $t('error.parts.pageInformation4') }}</span>
                    </p>
                    <p class="pageInfo">
                        <template v-if="!utils.isNullEmpty(touStore.touProfileUrl)">
                            <!--タフネス画面のURL-->
                            <a :href="touStore.touProfileUrl" class="btnText">{{ $t('error.parts.button1') }}</a>
                        </template>
                    </p>
                    <p class="pageInfo">{{ $t('error.parts.pageInformation5') }}<br />{{ $t('error.parts.pageInformation6') }}</p>
                </section>
            </div>
        </div>
    </section>
</template>
